// import { dashboard, admindashboard } from './dashboard';
// // ==============================|| MENU ITEMS ||============================== //

// const menuItems = {
//   items: [dashboard],
//   navAdminItems: [admindashboard]
// };

// export default menuItems;

 import { dashboard, admindashboard } from './dashboard';
// ==============================|| MENU ITEMS ||============================== //

const menuItem = {
  items: [dashboard],
  navAdminItems: [admindashboard],
  navHotelAdminItems: [dashboard]
};

export default menuItem;



